<template>
    <div v-loading="loading">
        <h2>Hello{{ currentUserName }}!</h2>
        <h3 class="orangetitle">My Submissions</h3>
        <el-table
            class="submissionstable"
            :data="tableData"
            empty-text="There are no submissions yet.">
            <el-table-column
                prop="created_at"
                label="Date"
                width="110">
            </el-table-column>
            <el-table-column
                prop="title"
                label="Project Title"
                width="180">
            </el-table-column>
            <el-table-column
                prop="entry_id"
                label="Entry ID"
                align="center"
                width="80">
            </el-table-column>
            <el-table-column
                prop="category"
                label="Category">
            </el-table-column>
            <el-table-column
                prop="fee"
                align="center"
                label="Fee"
                width="80">
            </el-table-column>
            <el-table-column
                prop="proforma"
                label="Pre-Invoice"
                class-name="invoicecol"
                width="140">
                <template slot-scope="scope">
                    <a v-if="scope.row.proforma" href="#" @click.prevent="getInvoice(scope.row.proforma, 'proforma')"
                       class="invoicedown">Download <i class="el-icon-bottom"></i></a>
                    <span v-else>N/A</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="invoice"
                label="Invoice"
                class-name="invoicecol"
                width="140">
                <template slot-scope="scope">
                    <a v-if="scope.row.invoice" href="#" @click.prevent="getInvoice(scope.row.invoice, 'invoice')"
                       class="invoicedown">Download <i class="el-icon-bottom"></i></a>
                    <span v-else>N/A</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="prev, pager, next, total"
            :total="total">
        </el-pagination>
    </div>
</template>

<script>

import accountApi from './api'

export default {
    computed: {},
    methods: {
        getInvoice(invoice_id, type) {
            window.location.href = `/api/v1/form-submissions/getInvoice/` + invoice_id + `?type=` + type + `&token=` + this.$auth.token()
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.loadData();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.loadData();
        },
        loadData() {
            this.loading = true;
            accountApi.history({
                formType: this.currentAward,
                page: this.currentPage,
                perPage: this.pageSize
            }).then((r) => {
                this.tableData = r.data.data;
                this.total = r.data.total;
            }).catch((err) => {

            }).finally(() => {
                this.loading = false;
            })
        }
    },
    watch: {},
    data: () => ({
        tableData: [],
        loading: false,
        currentPage: 1,
        pageSize: 10,
        total: 0
    }),
    created: function () {
        this.loadData();
    }
}
</script>
